import React, { Component } from "react";
import { Navigate } from "react-router-dom";
import { withRouter } from '../../common/with-router';
import {Card, Form, Button, Row, Col, Table, Dropdown} from "react-bootstrap";
import { FaRegEdit, FaSearch, FaFilter, FaEraser, FaRegClock, FaCheck, FaExclamationCircle } from "react-icons/fa";
import api from "../../services/api";
import { hasPerm } from '../../common/utils';
import AsyncSelect from 'react-select/async';
import Paginacao from '../../common/pagination';
import { formataDataExibicao, formataDataHoraExibicao, formatarValorLocal, getCurrentUser } from '../../common/utils';

class Autorizacoes extends Component {
    constructor(props) {
        super(props);
        this.onClickPagina = this.onClickPagina.bind(this);

        this.state = {
            listRegistros: [],
            error: "",
            busca: "",
            page_numb: 1,
            loading: true,
            filtro_somente_minhas: false,
        };

        this.statusConfig = {
            novo: { background: '#cde1ed', color: '#252f4a', text: 'Novo', icon: <FaRegClock /> },
            aprovado: { background: '#3cc172', color: '#fff', text: 'Aprovado', icon: <FaCheck /> },
            recusado: { background: '#eb4961', color: '#fff', text: 'Recusado', icon: <FaExclamationCircle /> }
        };

    }

    componentDidMount(){
        let dados_usuario = getCurrentUser();
        let ambiente_programa_id = dados_usuario['ambiente_programa_id'] ? dados_usuario['ambiente_programa_id'] : '';
        //o gestor logado vem das restricoes; usado no filtro "Somente as minhas"
        let restricao = dados_usuario['restricoes'] && dados_usuario['restricoes'].length > 0 ? dados_usuario['restricoes'][0] : {};

        this.setState({
            ambiente_programa_id: ambiente_programa_id,
            tipo_usuario: dados_usuario.tipo_usuario,
            meu_gestor_id: restricao['gestor_id'] || '',
        }, () => {
            this.consultaRegistros()
        })
    }

    consultaRegistros(){
        let dados_usuario = getCurrentUser();
        const programa_id = this.state.ambiente_programa_id ? this.state.ambiente_programa_id : this.state.filtro_programa_id;
        let filtros = '?page='+this.state.page_numb;
        this.setState({
            tipo_usuario: dados_usuario.tipo_usuario
        })

        if(this.state.filtro_data_inicio){
            filtros += '&data_inicio='+this.state.filtro_data_inicio
        }

        if(this.state.filtro_data_fim){
            filtros += '&data_fim='+this.state.filtro_data_fim
        }

        if(programa_id){
            filtros += `&programa_id=${programa_id}`
        }

        if(this.state.filtro_status){
            filtros += `&status_solicitacao=${this.state.filtro_status}`
        }

        if(this.state.filtro_atendimento_id){
            filtros += `&atendimento_id=${this.state.filtro_atendimento_id}`
        }

        //restringe às solicitações atribuídas ao gestor logado
        if(this.state.filtro_somente_minhas && this.state.meu_gestor_id){
            filtros += `&gestor_id=${this.state.meu_gestor_id}`
        }

        api.get(`/autorizacoes/${filtros}`)
        .then(response => {
            this.setState({
                loading: false,
                error: "",
                listRegistros: response.data
            });
        })
        .catch(error => {
            let erro_msg = 'Erro ao consultar autorizações, tente novamente.';

            if(error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response.status === 403){
                erro_msg = 'Você não tem permissão para acessar essa área';
            }

            this.setState({
                loading: false,
                error: erro_msg
            });
        });
    }

    handleChangeFiltros = (event, fieldName) => {
        if(fieldName == 'programa_id') {
            this.setState({
                filtro_programa_id: event.value, 
                filtro_programa_nome: event.label,  
                filtro_prestador_id: '',
                filtro_prestador_nome: ''
            }, () => {
                //this.carregaPrestadores("", true)
            });
        }
        else if(fieldName == 'prestador_id') {
            this.setState({ 
                filtro_prestador_id: event.value, 
                filtro_prestador_nome: event.label, 
            });
        }
        else {
            const { name, value } = event.target;
            this.setState({ [name]: value });
        }
    };

    carregaProgramas = async (inputValue) => {
        if(this.state.loading){
            try {
                let response;   
                if(this.state.ambiente_programa_id){
                    response = await api.get(`/programas/?programa_id=${this.state.ambiente_programa_id}`);
                }
                else{
                    response = await api.get(`/programas/?nome=${inputValue}`);
                }
                const opcoes = response.data.results.map(programa => {
                    if (programa.id === parseInt(this.state.ambiente_programa_id)) {
                        this.setState({
                            filtro_programa_id: programa.id,
                            filtro_programa_nome: programa.nome
                        });
                    }
                    return {
                        value: programa.id,
                        label: programa.nome
                    };
                });
                
                return opcoes;
            } catch (error) {
                console.error('Erro ao carregar programas:', error);
                return [];
            }
        }
    };


    renderRows = () => {   
        if('results' in this.state.listRegistros && this.state.listRegistros.results.length > 0){
            return this.state.listRegistros.results.map((item) =>
            <tr key={item.id}>
                <td>{item.id}</td>
                <td><a target="_blank" href={"/atendimentos/edit/"+item.dados_atendimento.uuid}>{item.atendimento_id}</a></td>
                <td>{item.dados_atendimento.paciente}</td>
                <td>{formataDataExibicao(item.data_solicitacao)}</td>
                <td>{item.dados_operador.nome || 'Não Informado'}</td>
                <td>{item.dados_gestor.nome || 'Sem responsável'}</td>
                <td><span style={{ padding: '5px 10px', fontSize: 12, borderRadius: 5, display: 'inline-block', backgroundColor: this.statusConfig[item.status_solicitacao].background, color: this.statusConfig[item.status_solicitacao].color }}>{this.statusConfig[item.status_solicitacao].icon} {this.statusConfig[item.status_solicitacao].text}</span></td>
                <td>
                    <Button variant="light" href={"/autorizacoes/edit/"+item.id} size="sm">
                        <FaRegEdit /> Editar
                    </Button>    
                </td>
            </tr>
            );
        }        

        return (
            <tr>
                <td colSpan={8}>Nenhuma autorização encontrada</td>
            </tr>
        );
    };

    onClickPagina(num_page) {
        this.setState({
            loading: true,
            page_numb: num_page
        });
        
        this.consultaRegistros()
    };

    filtrarAutorizacoes = (e) => {
        e.preventDefault();

        this.setState({
            loading: true
        })

        this.consultaRegistros()
    };

    limpaFiltro = () => {
        this.setState({
            busca: '',
            filtro_data_inicio: '',
            filtro_data_fim: '',
            filtro_programa_id: null,
            filtro_programa_nome: '',
            filtro_prestador_id: null,
            filtro_prestador_nome: '',
            filtro_atendimento_id: '',
            filtro_status: '',
            filtro_somente_minhas: false,
            page_numb: 1, // Reseta a paginação, se necessário
        }, () => {
            this.consultaRegistros(); // Chama a função para consultar registros com os filtros limpos
        });
    };

    render() {        
        if (!hasPerm('view_autorizacoes')) {
            return <Navigate to='/sem-permissao' />
        }

        return (
            <div>
                <Row className="align-items-center">
                    <Col sm={6} lg={6}>
                        <h4 className="page-title">Autorizações</h4>
                    </Col>                    
                </Row>
                <Card className="cardDestaque">
                    <Card.Body>                    
                        <h4>Filtros</h4>
                        <Form method="get" onSubmit={this.filtrarAutorizacoes}>
                            <Row>
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data Início</Form.Label>
                                        <Form.Control type="date" name="filtro_data_inicio" value={this.state.filtro_data_inicio} onChange={e => this.handleChangeFiltros(e, 'filtro_data_inicio')} />    
                                    </Form.Group>
                                </Col>
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Data Final</Form.Label>
                                        <Form.Control type="date" name="filtro_data_fim" value={this.state.filtro_data_fim} onChange={e => this.handleChangeFiltros(e, 'filtro_data_fim')} />    
                                    </Form.Group>
                                </Col>
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>ID Atendimento</Form.Label>
                                        <Form.Control 
                                            type="number" 
                                            name="filtro_atendimento_id" 
                                            value={this.state.filtro_atendimento_id} 
                                            onChange={e => this.handleChangeFiltros(e, 'filtro_atendimento_id')} 
                                            placeholder="Buscar por ID"
                                        />    
                                    </Form.Group>
                                </Col>
                                <Col sm={3} xs={12}> 
                                    <Form.Group className="mb-3">
                                        <Form.Label>Status</Form.Label>
                                        <Form.Select className="form-control"
                                            name="filtro_status" 
                                            value={this.state.filtro_status} 
                                            onChange={e => this.handleChangeFiltros(e, 'filtro_status')}
                                        >
                                            <option value="">Todos os Status</option>
                                            <option value="novo">Novo</option>
                                            <option value="aprovado">Aprovado</option>
                                            <option value="recusado">Recusado</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>

                                {this.state.tipo_usuario !== 'prestador' && (
                                    <Col sm={3} xs={12}> 
                                        <Form.Group className="mb-3">
                                            <Form.Label>Programas</Form.Label>
                                            <AsyncSelect           
                                                key={this.state.programa_id}                     
                                                cacheOptions
                                                loadOptions={this.carregaProgramas}
                                                defaultOptions
                                                name="programa_id"
                                                placeholder={'Buscar programa...'}
                                                noOptionsMessage={() => "Nenhum programa encontrado"}
                                                isDisabled={this.state.ambiente_programa_id ? true : false}
                                                onChange={e => this.handleChangeFiltros(e, 'programa_id')}
                                                value={this.state.filtro_programa_id ? { value: this.state.filtro_programa_id, label: this.state.filtro_programa_nome } : null}
                                            />
                                        </Form.Group>
                                    </Col>
                                )}

                                {this.state.tipo_usuario === 'gestor' && this.state.meu_gestor_id && (
                                    <Col sm={3} xs={12}>
                                        <Form.Group className="mb-3 mt-4">
                                            <Form.Check
                                                type="checkbox"
                                                id="filtro_somente_minhas"
                                                label="Somente as minhas"
                                                checked={this.state.filtro_somente_minhas}
                                                onChange={e => this.setState({ filtro_somente_minhas: e.target.checked })}
                                            />
                                        </Form.Group>
                                    </Col>
                                )}
                            </Row>
                            <Button type="submit" variant="secondary" size="sm">
                                <FaSearch /> Filtrar
                            </Button>
                            <Button type="button" variant="secondary" size="sm" onClick={() => this.limpaFiltro()}>
                                <FaEraser /> Limpar Filtro
                            </Button>
                        </Form> 

                        <Table responsive className="custom-table mt-3">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>ID Atendimento</th>
                                    <th>Paciente</th>
                                    <th>Data</th>
                                    <th>Operador</th>
                                    <th>Gestor Responsável</th>
                                    <th>Status</th>
                                    <th>Opções</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.loading ? (
                                <tr>
                                    <td colSpan={8}>Carregando...</td>
                                </tr>
                                ) : (
                                    this.state.error ? (
                                        <tr>
                                            <td colSpan={8}>{this.state.error}</td>
                                        </tr>
                                    ) : this.renderRows()
                                )}                                                       
                            </tbody>
                        </Table>       
                        { 
                            'results' in this.state.listRegistros && this.state.listRegistros.results.length > 0 && 
                            <Paginacao dados={this.state.listRegistros} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPagina} />
                        }                    
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

export default withRouter(Autorizacoes);